module.exports = "<span class=\"js-anchor\"></span>";